"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GRAPHQL_PAYMENT_ERRORS = void 0;
var GRAPHQL_PAYMENT_ERRORS;
(function (GRAPHQL_PAYMENT_ERRORS) {
    GRAPHQL_PAYMENT_ERRORS["PAYMENT_REQUEST_FAILURE"] = "PAYMENT_REQUEST_FAILURE";
})(GRAPHQL_PAYMENT_ERRORS = exports.GRAPHQL_PAYMENT_ERRORS || (exports.GRAPHQL_PAYMENT_ERRORS = {}));



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/methodOfPaymentAPI/bff/constants.js
// module id = 1332
// module chunks = 11